import { css } from 'styled-components';
export const LinkCSS = {
    default() {
        return css `
            color: ${({ theme, active }) => active ? theme.link.activeColor.toString() : theme.link.color.toString()};
            &:hover {
                color: ${({ theme }) => theme.link.hover.color.toString()};
            }
        `;
    },
    contrast() {
        return css `
            color: ${({ theme, active }) => active
            ? theme.link.contrastActiveColor.toString()
            : theme.link.contrastColor.toString()};
            &:hover {
                color: ${({ theme }) => theme.link.hover.contrastColor.toString()};
            }
        `;
    },
};
//# sourceMappingURL=LinkCSS.js.map